import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Sms = () => (
  <Box>
    <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
      SMS Mesajları
    </Typography>
    <Paper sx={{ p: 3 }}>
      <Typography>
        SMS kanalı üzerinden gönderilecek duyuru ve bilgilendirmeler burada yapılandırılacak. İçerik hazırlanmaya
        devam ediyor.
      </Typography>
    </Paper>
  </Box>
);

export default Sms;


